import { render } from "./EditSubject.vue?vue&type=template&id=1ad4c195"
import script from "./EditSubject.vue?vue&type=script&lang=js"
export * from "./EditSubject.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__